import React from 'react';
import { AddButton } from '../../buttons/Buttons';
import { RootState } from '../../../../../Redux/Store/store';
import { useSelector, useDispatch } from 'react-redux';
import { setZoomAnimAction } from '../../../../../Redux/Actions/Animator/zoom.anim.action';
import { AddAnimationPayloadInterface } from '../../../../../Redux/Actions/Animator/animation.list.action';
import { find, propEq } from 'ramda';
import { css } from 'glamor';

const disable = css({
    opacity: 0.2,
});

export const ZoomSection = () => {
    const zoomPercent: number = useSelector((state: RootState) => state.zoomAnim.value);
    const animation_list = useSelector((state: RootState) => state.AnimationList);
    const actual_animation: AddAnimationPayloadInterface = find(
        propEq('id', animation_list.actual_animation),
        animation_list.animations
    );

    const dispatch = useDispatch();

    const minZoom = 20;
    const maxZoom = 500;
    const zoomStep = 10;

    const handleInputZoom = (percentInput: number) => {
        const numberPercent: number = Math.round(percentInput);
        const finalZoom: number =
            numberPercent <= minZoom ? minZoom : numberPercent >= maxZoom ? maxZoom : numberPercent;
        dispatch(setZoomAnimAction({ value: finalZoom }));
    };

    return (
        <React.Fragment>
            {actual_animation === undefined ? (
                <React.Fragment>
                    <span className={`zoom-input-view ${disable}`}>
                        <input type="number" onChange={(event) => {}} value={zoomPercent} />
                        <span className="ml-1">%</span>
                    </span>
                    <AddButton className={`ml-2 ${disable}`}>
                        <span className="px-2" style={{ fontSize: '1rem' }}>
                            Reset
                        </span>
                    </AddButton>
                    <AddButton className={`ml-1 ${disable}`}>-</AddButton>
                    <AddButton className={`ml-1 ${disable}`}>+</AddButton>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <span className={`zoom-input-view`}>
                        <input
                            type="number"
                            onChange={(event) => handleInputZoom(Number(event.target.value))}
                            value={zoomPercent}
                        />
                        <span className="ml-1">%</span>
                    </span>
                    <AddButton className="ml-2" onClick={() => handleInputZoom(100)}>
                        <span className="px-2" style={{ fontSize: '1rem' }}>
                            Reset
                        </span>
                    </AddButton>
                    <AddButton
                        className="ml-1"
                        onClick={() => handleInputZoom(zoomPercent - zoomStep)}
                    >
                        -
                    </AddButton>
                    <AddButton
                        className="ml-1"
                        onClick={() => handleInputZoom(zoomPercent + zoomStep)}
                    >
                        +
                    </AddButton>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};
